import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { termAnchor } from '@/music/text/segments';

/** Under the hint of a term in a text: the way to its entry here. */
export function GlossaryLink({ termKey }: { termKey: string }) {
  const { t } = useTranslation();
  return (
    <Link
      to={`/glossary#${termAnchor(termKey)}`}
      className="block text-xs font-medium text-brand hover:underline"
    >
      {t('glossary.open')} →
    </Link>
  );
}
